import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-bell-icon',
    templateUrl: './bell-icon.component.html',
    styleUrls: ['./bell-icon.component.scss']
})
export class BellIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 20;
    }
}
